import dataLayerApi from "./dataLayerApi";
import {
  dataAttributes,
  getDataFromTargetOrThrow,
  getHrefFromTarget,
  tryGetDataFromTarget,
} from "./get-data-from-entry";
import { querySelectorAllDeep } from "./query-selector";
import { isHtmlElement } from "./closest-data-sit-attribute";

export const THRESHOLD = 300;

const teaserObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (isHtmlElement(entry.target)) {
        const element = entry.target;
        if (!entry.isIntersecting) {
          const timeoutId = element.dataset[dataAttributes.teaserTimeout];
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          return;
        }

        element.dataset[dataAttributes.teaserTimeout] = String(
          setTimeout(() => {
            dataLayerApi.trackTeaserImpression({
              destination: getHrefFromTarget(element) ?? "",
              label:
                tryGetDataFromTarget(element, dataAttributes.teaserLabel) ?? "",
              headline:
                getDataFromTargetOrThrow(
                  element,
                  dataAttributes.teaserHeadline,
                ) ?? "",
              component: element,
            });
            element.dataset[dataAttributes.teaserImpressed] = "";
            unobserveTeaserElement(element);
          }, THRESHOLD),
        );
      }
    });
  },
  { rootMargin: "0px 0px -30% 0px" },
);

export function startObservingTeaserElements() {
  Array.from(
    querySelectorAllDeep('[data-sit-teaser]:not([data-sit-teaser="manual"])'),
  ).forEach((element) => observeTeaserElement(element));
}

export function unobserveTeaserElement(element: HTMLElement) {
  teaserObserver.unobserve(element);
}

export function observeTeaserElement(element: HTMLElement) {
  if (element.dataset[dataAttributes.teaserImpressed] === undefined) {
    teaserObserver.observe(element);
  }
}

const impressionObserver = new IntersectionObserver(
  (entries) => {
    entries.forEach((entry) => {
      if (isHtmlElement(entry.target)) {
        const element = entry.target;
        if (!entry.isIntersecting) {
          const timeoutId = element.dataset[dataAttributes.impressionTimeout];
          if (timeoutId) {
            clearTimeout(timeoutId);
          }
          return;
        }

        element.dataset[dataAttributes.impressionTimeout] = String(
          setTimeout(() => {
            dataLayerApi.trackImpression({
              type: getDataFromTargetOrThrow(
                element,
                dataAttributes.impressionType,
              )!,
              label:
                tryGetDataFromTarget(element, dataAttributes.impressionLabel) ??
                "",
              headline:
                tryGetDataFromTarget(
                  element,
                  dataAttributes.impressionHeadline,
                ) ?? "",
              component: element,
            });
            element.dataset[dataAttributes.teaserImpressed] = "";
            unobserveImpressionElement(element);
          }, THRESHOLD),
        );
      }
    });
  },
  { rootMargin: "0px 0px 0px 0px" },
);

export function startObservingImpressionElements() {
  Array.from(querySelectorAllDeep("[data-sit-impression]")).forEach((element) =>
    observeImpressionElement(element),
  );
}

export function unobserveImpressionElement(element: HTMLElement) {
  impressionObserver.unobserve(element);
}

export function observeImpressionElement(element: HTMLElement) {
  if (element.dataset[dataAttributes.teaserImpressed] === undefined) {
    impressionObserver.observe(element);
  }
}
